export default __webpack_public_path__ + "static/media/Reset password.4b18c623.svg";